<template>
  <component :is="tag">
    <span v-html="text"></span>
  </component>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },
  tag: {
    type: String,
    default: 'div',
  },
});
</script>
